import { BitkitAlert, BitkitEmptyState, IconDoc } from '@bitrise/bitkit-v2';

type LogEmptyState = 'WaitingToBeStarted' | 'Loading' | 'LoadingError' | 'HasNoLogs' | 'LogsDeleted';

type BuildLogEmptyStateProps = {
  state: LogEmptyState;
};

const BuildLogEmptyState = ({ state }: BuildLogEmptyStateProps) => {
  switch (state) {
    case 'WaitingToBeStarted':
      return (
        <BitkitEmptyState
          loading
          icon={IconDoc}
          headingText="Build not started yet"
          bodyText="Logs will stream here as soon as the build begins."
        />
      );
    case 'Loading':
      return (
        <BitkitEmptyState
          loading
          icon={IconDoc}
          headingText="Waiting for build logs"
          bodyText="The logs of your build will appear here."
        />
      );
    case 'LoadingError':
      return <BitkitAlert variant="critical" messageText="Failed to load logs." />;
    case 'HasNoLogs':
      return (
        <BitkitEmptyState
          icon={IconDoc}
          headingText="No logs created"
          bodyText="This build didn't generate any logs."
        />
      );
    case 'LogsDeleted':
      return <BitkitAlert variant="info" messageText="This build has no logs. They might have been deleted." />;
    default:
      return null;
  }
};

export default BuildLogEmptyState;
